"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _lodash = require("lodash");
var _downCaretDarkBlue = _interopRequireDefault(require("../../images/down-caret-dark-blue.svg"));
var _rightCaretLightGray = _interopRequireDefault(require("../../images/right-caret-light-gray.svg"));
var _formatID = _interopRequireDefault(require("../../utils/formatID"));
var _generateLinks = _interopRequireWildcard(require("../../utils/generateLinks"));
var _useMouse = _interopRequireDefault(require("../../utils/hooks/useMouse"));
var _useFocus = require("../../utils/hooks/useFocus");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const MobileMegaMenuSubCategory = _ref => {
  let {
    name,
    links,
    toggleCategory,
    isOpen,
    closeDropDown,
    Link,
    parentOpen,
    categoryId,
    subCategoryLink
  } = _ref;
  const {
    mouse
  } = (0, _useMouse.default)();

  //Sets references to both top level menu elements
  const [collapsedMenu, setCollapsedMenu] = (0, _useFocus.useFocus)();
  const [uncollapsedMenu, setUncollapsedMenu] = (0, _useFocus.useFocus)();
  const generateTertiaryMenu = () => {
    return (0, _generateLinks.default)(links, "ter-mobile-mega-menu-category__name", closeDropDown, name, mouse, Link, 4);
  };
  const toggleCategoryWithEnter = (event, categoryId, direction) => {
    if (!mouse) {
      // checks that a user hits the enter key to open the modal
      if (event.keyCode === 13) {
        toggleCategory(categoryId);
        //Accessibility - set the focus to the incoming menu
        if (direction === "open") {
          setCollapsedMenu();
        } else {
          setUncollapsedMenu();
        }
      }
    }
  };
  const handleClick = categoryId => {
    toggleCategory(categoryId);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("section", {
    className: `ter-mobile-mega-menu--reveal--from-right ${isOpen ? `ter-mobile-mega-menu--reveal--from-right--visible` : ""}`
  }, /*#__PURE__*/_react.default.createElement("p", {
    tabIndex: mouse ? "" : "0",
    onClick: () => toggleCategory(categoryId),
    onKeyDown: e => toggleCategoryWithEnter(e, categoryId, "open"),
    className: `ter-mobile-mega-menu__name ${isOpen ? "ter-mobile-mega-menu__name--open" : ""} ${mouse ? "" : "tabFocus"}`,
    "aria-haspopup": "menu",
    "aria-expanded": isOpen,
    ref: uncollapsedMenu
  }, name, /*#__PURE__*/_react.default.createElement("img", {
    className: `ter-mobile-mega-menu__caret ${isOpen ? "ter-mobile-mega-menu__caret--up" : "ter-mobile-mega-menu__caret--down"}`,
    src: _rightCaretLightGray.default,
    alt: "caret icon"
  })), /*#__PURE__*/_react.default.createElement("ul", {
    className: `ter-mobile-mega-menu-category__submenu ${isOpen ? "ter-mobile-mega-menu-category__submenu--is-open" : ""}`
  }, generateTertiaryMenu(), subCategoryLink?.url && (0, _generateLinks.generateSingleLink)(subCategoryLink, "ter-mobile-mega-menu-category__name ter-mobile-mega-menu__sub-category-link", closeDropDown, Link))), /*#__PURE__*/_react.default.createElement("section", {
    className: `ter-mobile-mega-menu-category ${parentOpen ? "" : "ter-mobile-mega-menu-category--hidden"}`
  }, /*#__PURE__*/_react.default.createElement("p", {
    tabIndex: mouse ? "" : "0",
    onClick: () => handleClick(categoryId),
    onKeyDown: e => toggleCategoryWithEnter(e, categoryId, "close"),
    className: `ter-mobile-mega-menu-category__name ${isOpen ? "ter-mobile-mega-menu-category__name--hidden" : ""} ${mouse ? "" : "tabFocus"}`,
    "aria-haspopup": "menu",
    "aria-expanded": !isOpen,
    ref: collapsedMenu,
    "data-depth": 3
  }, name, /*#__PURE__*/_react.default.createElement("img", {
    className: `ter-mobile-mega-menu-category__caret`,
    src: _downCaretDarkBlue.default,
    alt: "caret icon"
  }))));
};
var _default = MobileMegaMenuSubCategory;
exports.default = _default;